import React from 'react';

const TiendaDetailModal = ({ tienda, onClose }) => {
    if (!tienda) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-start mb-6">
                        <h2 className="text-2xl font-bold text-gray-900">Detalles de la Tienda</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-500"
                        >
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div className="space-y-6">
                        {/* Información básica */}
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h3 className="text-lg font-medium text-gray-900 mb-4">Información Básica</h3>
                            <div className="space-y-4">
                                <div>
                                    <span className="text-sm font-medium text-gray-500">Nombre</span>
                                    <p className="mt-1 text-sm text-gray-900">{tienda.nombre}</p>
                                </div>
                                {tienda.descripcion && (
                                    <div>
                                        <span className="text-sm font-medium text-gray-500">Descripción</span>
                                        <p className="mt-1 text-sm text-gray-900 whitespace-pre-wrap break-words">
                                            {tienda.descripcion}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Ubicación */}
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h3 className="text-lg font-medium text-gray-900 mb-4">Ubicación</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div>
                                    <span className="text-sm font-medium text-gray-500">Dirección</span>
                                    <p className="mt-1 text-sm text-gray-900">
                                        {tienda.via} {tienda.calle}, {tienda.numero}
                                    </p>
                                </div>
                                <div>
                                    <span className="text-sm font-medium text-gray-500">Localidad</span>
                                    <p className="mt-1 text-sm text-gray-900">
                                        {tienda.poblacion}, {tienda.region}, {tienda.pais}
                                    </p>
                                </div>
                                {(tienda.lat !== 0 || tienda.lng !== 0) && (
                                    <div className="col-span-2">
                                        <span className="text-sm font-medium text-gray-500">Coordenadas</span>
                                        <p className="mt-1 text-sm text-gray-900">
                                            Lat: {tienda.lat}, Lng: {tienda.lng}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Contacto */}
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h3 className="text-lg font-medium text-gray-900 mb-4">Información de Contacto</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div>
                                    <span className="text-sm font-medium text-gray-500">Teléfono</span>
                                    <p className="mt-1 text-sm text-gray-900">{tienda.telefono || 'No especificado'}</p>
                                </div>
                                <div>
                                    <span className="text-sm font-medium text-gray-500">Email</span>
                                    <p className="mt-1 text-sm text-gray-900">{tienda.email || 'No especificado'}</p>
                                </div>
                                {tienda.web && (
                                    <div>
                                        <span className="text-sm font-medium text-gray-500">Sitio Web</span>
                                        <p className="mt-1 text-sm text-gray-900">{tienda.web}</p>
                                    </div>
                                )}
                                {tienda.facebook && (
                                    <div>
                                        <span className="text-sm font-medium text-gray-500">Facebook</span>
                                        <p className="mt-1 text-sm text-gray-900">{tienda.facebook}</p>
                                    </div>
                                )}
                                {tienda.instagram && (
                                    <div>
                                        <span className="text-sm font-medium text-gray-500">Instagram</span>
                                        <p className="mt-1 text-sm text-gray-900">{tienda.instagram}</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Propietario */}
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h3 className="text-lg font-medium text-gray-900 mb-4">Propietario</h3>
                            {tienda.usuario ? (
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <span className="text-sm font-medium text-gray-500">Nombre</span>
                                        <p className="mt-1 text-sm text-gray-900">{tienda.usuario.nombre}</p>
                                    </div>
                                    <div>
                                        <span className="text-sm font-medium text-gray-500">Email</span>
                                        <p className="mt-1 text-sm text-gray-900">{tienda.usuario.email}</p>
                                    </div>
                                </div>
                            ) : (
                                <p className="text-sm text-gray-500">No hay propietario asignado</p>
                            )}
                        </div>

                        {/* Estadísticas */}
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h3 className="text-lg font-medium text-gray-900 mb-4">Estadísticas</h3>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <span className="text-sm font-medium text-gray-500">Clientes</span>
                                    <p className="mt-1 text-sm text-gray-900">{tienda.clientes?.length || 0}</p>
                                </div>
                                <div>
                                    <span className="text-sm font-medium text-gray-500">Trabajadores</span>
                                    <p className="mt-1 text-sm text-gray-900">{tienda.trabajadores?.length || 0}</p>
                                </div>
                            </div>
                        </div>

                        <div className="text-sm text-gray-500">
                            Fecha de creación: {new Date(tienda.fecha).toLocaleDateString()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TiendaDetailModal; 